import { Table } from "react-bootstrap";
interface TableProps {
  dataSource: any;
  fields: any;
  onRowRemoved?: Function;
  onClearAll?: Function;
  showRemoveIcon: boolean;
  height?: string;
  bordered?: boolean;
}
export default (props: TableProps) => {
  const {
    dataSource,
    fields,
    onRowRemoved,
    onClearAll,
    showRemoveIcon,
    bordered,
  } = props;
  const handleRowRemoved = (index: number) => {
    if (onRowRemoved) onRowRemoved(index);
  };
  const handleClearAll = () => {
    if (onClearAll) onClearAll();
  };
  return (
    <Table responsive="sm" bordered size="sm">
      <thead>
        <tr className="table-header">
          {fields.map((value: any, columnIndex: number) => {
            return (
              <th key={columnIndex}>
                {value.renderHeader ? value.renderHeader() : value.text}
              </th>
            );
          })}
          {showRemoveIcon && (
            <th>
              {dataSource.length > 1 && (
                <div
                  className="e-image-bakground-icon e-remove-icon"
                  onClick={handleClearAll}
                ></div>
              )}
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {dataSource.map((data: any, index: number) => {
          return (
            <tr key={index} className="table-body">
              {fields.map((value: any, columnIndex: number) => {
                return (
                  <td key={columnIndex} style={{ verticalAlign: "middle" }}>
                    {value.render ? value.render(data) : data[value.field]}
                  </td>
                );
              })}
              {showRemoveIcon && (
                <td onClick={handleRowRemoved.bind(null, index)}>
                  <div className="e-image-bakground-icon e-remove-icon"></div>
                </td>
              )}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
